import React, {useState} from "react";
import {Tooltip} from "../../../../designSystem/components/Tooltip";
import {ActionButton} from "../../../../designSystem/components/ActionButton";

export const QuickReplyInput = ({
  item,
  onChangeOption,
  onChangeText,
  onRemoveItem,
}) => {
  const [isEditMode, setIsEditMode] = useState<boolean>(true);
  const onSaveItem = () => setIsEditMode(false);
  const onClickEdit = () => setIsEditMode(true);

  if (isEditMode)
    return (
      <div className="flex flex-row items-center gap-2 mb-2">
        <div className="flex flex-1 border">
          <input
            className="w-full p-1"
            value={item.label}
            onChange={onChangeOption}
            placeholder="選項"
          />
        </div>
        <div className="flex flex-1 border">
          <input
            className="w-full p-1"
            value={item.action?.text || ''}
            onChange={onChangeText}
            placeholder="回應"
          />
        </div>
        <div className="flex">
          <ActionButton onClick={onSaveItem} iconName="fa-save" variant="outline" />
        </div>
        <div className="flex">
          <ActionButton onClick={onRemoveItem} iconName="fa-trash" variant="outline" color="warning" />
        </div>
      </div>
    )

  return (
    <div className="flex flex-row items-center gap-2 mb-2 group">
      <div className="flex flex-1 justify-center pt-2 relative group text-blue-900">
        <Tooltip
          placement="top"
          content={
            <>當使用者選擇此選項，會回應「{item.action?.text}」</>
          }
        >
          <span className="truncate max-w-[240px]">{item.label}</span>
        </Tooltip>
        <div className="absolute right-3 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition">
          <ActionButton
            iconName="fa-pencil"
            onClick={onClickEdit}
            variant="ghost"
          />
        </div>
      </div>
    </div>
  )
}
